// Downloading an Excel file made in the browser (the Excel report, utils/excelReport): the workbook as a file, saved
// like any other download (the browser's download settings decide where it goes).

export const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export async function workbookBlob(workbook) {
  return new Blob([await workbook.xlsx.writeBuffer()], { type: XLSX_MIME });
}

/** Downloads the file, as a regular browser download. */
export function downloadFile(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
